const READ_PLATFORM_PATH = process.env.READ_PLATFORM_PATH
const PLATFORM_PATH = process.env.PLATFORM_PATH
const SSO_WEB_URL = process.env.SSO_WEB_URL
const constant = {
}


if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
    constant.TOKENPARAMS = 'mweb'
      } else {
        constant.TOKENPARAMS = 'web'
      }

// 公用的appCode
constant.COMMON_APPCODE = 'bdks'
constant.read_web_url = READ_PLATFORM_PATH
constant.PLATFORM_PATH = PLATFORM_PATH
constant.SSO_WEB_URL = SSO_WEB_URL
// constant.read_web_url = 'http://192.168.130.95:9051'

// 品类CODE
// constant.pl_ts = 'ts' // 图书
// constant.pl_ptts = 'ptts' // 普通图书
// constant.pl_gf = 'gf' // 规范
// constant.pl_bz = 'bz' // 规范
// constant.pl_al = 'al' // 案例
// constant.pl_tuku = 'tuku' // 图库ptts
// constant.pl_qk = 'qk' // 期刊
// constant.pl_ksjc = 'ksjc' // 考试教材
// constant.pl_sp = 'sp' // 视频
// constant.pl_kejian = 'kejian' // 课件
// constant.pl_ptzy = 'ptzy' // 配套资源
// constant.pl_tp = 'tp' // 图片
// constant.pl_st = 'st' // 试题
// constant.pl_kec = 'ck' // 课程
// constant.pl_zlj = 'JZ02-ZLJ' // 室内设计 室内设计资料集（第二版）
// constant.pl_hpjzxbsjtk = 'tuku' // 室内设计 海派建筑细部设计图库
// constant.pl_zlj = 'zlj' // 室内设计 室内设计资料集（第二版）
// constant.pl_hpjzxbsjtk = 'tuku' // 室内设计 海派建筑细部设计图库
// constant.pl_wz = 'wz' // 文章
// constant.pl_lxcbw = 'lxcbw' // 连续出版物

constant.pl_ts = 'ts' // 图书
constant.pl_ptts = 'ptts' // 普通图书
constant.pl_gf = 'bz' // 规范
constant.pl_al = 'al' // 案例
constant.pl_xxzl = 'xxzl' // 学习资料
constant.pl_tuku = 'tuku' // 图库ptts
constant.pl_qk = 'qk' // 期刊
constant.pl_ksjc = 'ksjc' // 考试教材
constant.pl_sp = 'sp' // 视频
constant.pl_yp = 'yp' // 音频
constant.pl_kejian = 'kejian' // 课件
constant.pl_ptzy = 'ptzy' // 配套资源
constant.pl_tp = 'tp' // 图片
// constant.pl_st = 'st' // 试题
// constant.pl_sj = 'sj' // 试卷
// constant.pl_xt = 'xt' // 习题
constant.pl_ypk = 'ypk' // 音频课
constant.pl_kejian = 'kj' // 课件
constant.pl_st = 'st' // 试题
constant.pl_sj = 'sj' // 试卷
constant.pl_xt = 'xt' // 习题
constant.pl_tk = 'tk' // 题库
constant.pl_kec = 'ck' // 课程
constant.pl_zlj = 'zlj' // 室内设计 室内设计资料集（第二版）
constant.pl_hpjzxbsjtk = 'tuku' // 室内设计 海派建筑细部设计图库
constant.pl_wz = 'wz' // 文章
constant.pl_lxcbw = 'lxcbw' // 连续出版物
constant.pl_ptzy = 'ptzy' // 配套资源

// 模块CODE
constant.zgtcjzyzjyywh = 'zgtcjzyzjyywh' // 中国传统建筑营造技艺与文化
constant.dfjzyzjy = 'dfjzyzjy' // 中国传统建筑营造技艺与文化--地方建筑营造技艺--模块查询
constant.szgb = 'szgb' // 中国传统建筑营造技艺与文化--神州瑰宝--模块查询
constant.szcc = 'szcc' // 中国传统建筑营造技艺与文化--数字长城--模块查询

constant.jzsjzlj = 'jzsjzlj' // 建筑设计资料
constant.jzsjzljdeb = 'jzsjzljdeb' // 建筑设计资料--建筑设计资料集（第二版）
constant.jzsjzl_ts = 'JZSJZL-ts' // 建筑设计资料--建筑设计资料集
constant.jzsjzl_qk = 'JZSJZL-qk' // 建筑设计资料--建筑设计资料集
constant.jzsjzl_bzgf = 'JZSJZL-bzgf' // 建筑设计资料--建筑设计资料集
constant.jzsjzl_al = 'JZSJZL-al' // 建筑设计资料--建筑设计资料集
constant.jzsjzl_spk = 'JZSJZL-spk' // 建筑设计资料--建筑设计资料集

constant.jzszyzgks = 'jzszyzgks' // 建筑师执业资格考试
constant.yjzcjzs = 'yjzcjzs' // 建筑师执业资格考试--一级
constant.ejzcjzs = 'ejzcjzs' // 建筑师执业资格考试--二级
constant.tk = 'tk' // 建筑师执业资格考试 - 题库

constant.bim = 'bim' // BIM
constant.gjk = 'gjk' // BIM--构件库
constant.mxk = 'mxk' // BIM--模型库
constant.bim_ksjc = 'BIM-ksjc' // BIM--考试教材
constant.bim_kj = 'BIM-kj' // BIM--课件
constant.bim_gcal = 'BIM-gcal' // BIM--工程案例
constant.bim_kc = 'BIM-kc' // BIM--课程
constant.bim_wdhd = 'BIM-wdhd' // BIM--问答互动

constant.yljg = 'yljg' // 园林景观
constant.fjylzlj = 'fjylzlj' // 园林景观 风景园林资料集--模块查询
constant.jgsj = 'jgsj' // 园林景观 景观设计--模块查询
constant.alsc = 'alsc' // 园林景观 案例素材
constant.yljg_ts = 'YLJG-TS' // 园林景观 图书
constant.yljg_spk = 'YLJG-SPK' // 园林景观 视频课
constant.yljg_qk = 'YLJG-QK' // 园林景观 期刊
constant.yljg_bzgf = 'YLJG-BZGF' // 园林景观 标准规范

constant.jzsb = 'jzsb' // 建筑设备
constant.sygrktsjsc = 'sygrktsjsc' // 建筑设备 实用供热空调设计手册
constant.jzsb_ts = 'JZSB-ts' // 建筑设备 图书
constant.jzsb_bzgf = 'JZSB-bzgf' // 建筑设备
constant.jzsb_kj = 'JZSB-kj' // 建筑设备
constant.jzsb_dhsc = 'JZSB-dhsc' // 建筑设备
constant.jzsb_gcal = 'JZSB-gcal' // 建筑设备

constant.snsj = 'SNSJ' // 室内设计
constant.hpjzxbsjtk = 'hpjzxbsjtk' // 室内设计  海派建筑细部设计图库--模块查询
constant.sjsjzljdeb = 'snsjzlj' // 室内设计 室内设计资料集（第二版）
constant.zljzzzy = 'zljzzzy' // 室内设计 室内设计资料集（第二版） 资料集增值资源
constant.dspd = 'dspd' // 室内设计 室内设计资料集（第二版） 大师频道
constant.yxcp = 'yxcp' // 室内设计 音像产品
constant.snsj_qk = 'SNSJ-qk' // 室内设计 期刊

export default constant



// WEBPACK FOOTER //
// ./src/api/constant.js